import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=7c6f4989&scoped=true&"
import script from "./benefit.vue?vue&type=script&lang=js&"
export * from "./benefit.vue?vue&type=script&lang=js&"
import style0 from "./benefit.vue?vue&type=style&index=0&id=7c6f4989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f4989",
  null
  
)

export default component.exports